import { findAndRemoveAttachment } from 'models/answers/snippet_helpers';
import Snippet from 'models/answers/snippet';

export default class RemoveUpload {
  constructor(context) {
    this.context = context;
  }

  run({ uploadId }) {
    let composition = this.context.stores.snippetComposition.get();
    if (!findAndRemoveAttachment({ snippet: composition, id: uploadId })) {
      return;
    }
    this.context.stores.snippetComposition.set(composition);
    this.context.stores.snippetComposition.clearErrors();

    let path = Snippet.getUploadPath(composition.id, uploadId);
    this.context.gateways.snippetUpload.remove(path);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/remove_upload.js